import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, input, output, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { IconComponent } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileInputComponent),
      multi: true,
    },
  ],
  imports: [IconComponent, MatTooltip, NgClass, FormsModule, ApmTranslatePipe],
})
export class FileInputComponent implements ControlValueAccessor {
  readonly tooltip = input('');
  readonly acceptedFile = input('*/*');
  readonly showInput = input(false);
  readonly disabled = input(false);

  readonly selectedFile = signal<File | undefined>(undefined);

  onChange: (value: File | null) => void = () => {};
  onTouch: () => void = () => {};

  documentUploaded = output<File>();

  writeValue(value: File | null): void {
    this.selectedFile.set(value || undefined);
  }

  registerOnChange(fn: (value: File | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  uploadDocument(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0] || null;
    this.onChange(file);
    this.selectedFile.set(file || undefined);
    if (file) {
      this.documentUploaded.emit(file);
    }
  }
}
